import React from "react";
import {Modal, ModalDialog, Typography, Button, Box} from "@mui/joy";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {Experimental_CssVarsProvider as CssVarsProvider} from "@mui/material/styles";
import {Chip as ChipMaterial, Paper, Stack} from "@mui/material";
import {CashBoxStatusColors} from "../../types/enumeration/CashBoxStatusColors";
import {CashBoxStatus} from "../../types/enumeration/CashBoxStatus";
import {CashBoxStatusNames} from "../../types/enumeration/CashBoxStatusNames";
import moment from "moment";
import {PurchaseApprovalStatusColors} from "../../types/enumeration/PurchaseApprovalStatusColors";
import {PurchaseApprovalStatus} from "../../types/enumeration/PurchaseApprovalStatus";
import {PurchaseApprovalStatusNames} from "../../types/enumeration/PurchaseApprovalStatusNames";
import {ServiceOrderStatus} from "../../types/enumeration/ServiceOrderStatus";
import {ServiceOrderStatusColors} from "../../types/enumeration/ServiceOrderStatusColors";
import {ServiceOrderStatusNames} from "../../types/enumeration/ServiceOrderStatusNames";
import {LiquidationStatusColors} from "../../types/enumeration/LiquidationStatusColors";
import {LiquidationStatus} from "../../types/enumeration/LiquidationStatus";
import {LiquidationStatusNames} from "../../types/enumeration/LiquidationStatusNames";
import {ServiceOrderEvaluationStatusColors} from "../../types/enumeration/ServiceOrderEvaluationStatusColors";
import {ServiceOrderEvaluationStatusNames} from "../../types/enumeration/ServiceOrderEvaluationStatusNames";
import {ServiceOrderEvaluationStatus} from "../../types/enumeration/ServiceOrderEvaluationStatus";

interface ConfirmationModalProps {
  open: boolean;
  title: string;
  history: Array<any> | undefined;
  onCancel: () => void;
  historyType: string;
}

const StatusHistoryModal: React.FC<ConfirmationModalProps> = ({open, title, history, onCancel, historyType}) => {
  return (
    <Modal open={open} onClose={onCancel}>
      <ModalDialog
        sx={{
          width: 800,
          borderRadius: 'md',
          p: 3,
          boxShadow: 'lg',
          maxHeight: 700,
          overflow: "scroll"
        }}
      >
        <Typography level="h4">{title}</Typography>

        <Box sx={{ display: 'flex', gap: 1, width: '100%', flexDirection: 'column' }}>
          {history && history.length === 0 &&
            <CssVarsProvider>
              <Paper elevation={2}>
                <Typography sx={{width: '100%', height: 50, textAlign: 'center', pt: 1.5}}>No hay estado para mostrar</Typography>
              </Paper>
            </CssVarsProvider>
          }
          {history?.map((item) => (
            <CssVarsProvider>
              <Paper elevation={2}>
                <Stack
                  direction="row"
                  spacing={1}
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{p: 1, width: '100%'}}
                >
                  {historyType === "cashBox" &&
                    <ChipMaterial
                      color={CashBoxStatusColors[CashBoxStatus[item.newStatus as keyof typeof CashBoxStatus]]}
                      label={CashBoxStatusNames[CashBoxStatus[item.newStatus as keyof typeof CashBoxStatus]]}
                      sx={{width: 200, fontWeight: 'bold', fontSize: 15}}
                    />
                  }
                  {historyType === "purchase" &&
                    <ChipMaterial
                      color={PurchaseApprovalStatusColors[PurchaseApprovalStatus[item.newStatus as keyof typeof PurchaseApprovalStatus]]}
                      label={PurchaseApprovalStatusNames[PurchaseApprovalStatus[item.newStatus as keyof typeof PurchaseApprovalStatus]]}
                      sx={{width: 200, fontWeight: 'bold', fontSize: 18}}/>
                  }
                  {historyType === "serviceOrder" &&
                    <ChipMaterial
                      color={ServiceOrderStatusColors[ServiceOrderStatus[item.newStatus as keyof typeof ServiceOrderStatus]]}
                      label={ServiceOrderStatusNames[ServiceOrderStatus[item.newStatus as keyof typeof ServiceOrderStatus]]}
                      sx={{width: 200, fontWeight: 'bold', fontSize: 18}}/>
                  }
                  {historyType === "serviceOrderEvaluation" &&
                    <ChipMaterial
                      color={ServiceOrderEvaluationStatusColors[ServiceOrderEvaluationStatus[item.newStatus as keyof typeof ServiceOrderEvaluationStatus]]}
                      label={ServiceOrderEvaluationStatusNames[ServiceOrderEvaluationStatus[item.newStatus as keyof typeof ServiceOrderEvaluationStatus]]}
                      sx={{width: 200, fontWeight: 'bold', fontSize: 18}}/>
                  }
                  {historyType === "liquidation" &&
                    <ChipMaterial
                      color={LiquidationStatusColors[LiquidationStatus[item.newStatus as keyof typeof LiquidationStatus]]}
                      label={LiquidationStatusNames[LiquidationStatus[item.newStatus as keyof typeof LiquidationStatus]]}
                      sx={{width: 200, fontWeight: 'bold', fontSize: 18}}/>
                  }
                  <Typography sx={{pr: 1}}>
                    {`${item.changedBy.lastName + ', ' + item.changedBy.name + ' - ' + moment(item.changedAt).format('DD/MM/YYYY hh:mm:ss')}`}
                  </Typography>
                </Stack>
                {item.comments &&
                    <Typography sx={{pl: 2, pb: 1, pr: 2, width: '100%'}}><b><u>Comentarios:</u></b> {item.comments}</Typography>
                }
              </Paper>
            </CssVarsProvider>
          ))}
        </Box>
        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={2}>
          <Button variant="outlined" onClick={onCancel} endDecorator={<HighlightOffIcon />}>
            Cerrar
          </Button>
        </Stack>
      </ModalDialog>
    </Modal>
  );
};

export default StatusHistoryModal;